(() => {
  const TARGET_TEXT = '10% de descuento';
  const HOST_SELECTOR = 'shopify-forms-embed, form-embed';
  const NATIVE_MARKER = 'data-marston-native-teaser';
  const SHADOW_STYLE_ID = 'marston-native-teaser-hidden-style';
  const LAUNCHER_ID = 'marston-discount-launcher';
  const DOCUMENT_STYLE_ID = 'marston-discount-launcher-style';
  const DISMISSED_KEY = 'marston-discount-launcher-dismissed';

  let currentTeaser = null;
  let dismissed = false;
  const watchedHosts = new WeakSet();

  function normalize(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function readDismissed() {
    try {
      return window.sessionStorage.getItem(DISMISSED_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function rememberDismissed() {
    try {
      window.sessionStorage.setItem(DISMISSED_KEY, '1');
    } catch (error) {
      // sessionStorage can be unavailable in restrictive browsing modes.
    }
  }

  function findNativeTeaser(root) {
    if (!root) return null;

    const likely = Array.from(root.querySelectorAll('button[class*="_teaser"]'));
    const candidates = likely.length ? likely : Array.from(root.querySelectorAll('button'));

    return candidates.find((button) => {
      const text = normalize(button.textContent);
      const aria = normalize(button.getAttribute('aria-label'));
      return text.includes(TARGET_TEXT) || aria.includes(TARGET_TEXT);
    }) || null;
  }

  function ensureShadowStyle(root) {
    if (!root || root.getElementById(SHADOW_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = SHADOW_STYLE_ID;
    style.textContent = `
      button[${NATIVE_MARKER}="true"] {
        display: none !important;
      }
    `;
    root.appendChild(style);
  }

  function ensureDocumentStyle() {
    if (document.getElementById(DOCUMENT_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = DOCUMENT_STYLE_ID;
    style.textContent = `
      #${LAUNCHER_ID} {
        position: fixed;
        left: 0;
        top: 50%;
        z-index: 9998;
        width: 40px;
        min-width: 40px;
        height: 122px;
        margin: 0;
        padding: 8px 4px 9px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px;
        box-sizing: border-box;
        color: #fff;
        background: #101010;
        border: 1px solid rgba(255, 255, 255, 0.22);
        border-left: 0;
        border-radius: 0 10px 10px 0;
        box-shadow: 5px 7px 18px rgba(0, 0, 0, 0.28);
        transform: translateY(-50%);
        transition: border-color 0.18s ease, box-shadow 0.18s ease;
      }

      #${LAUNCHER_ID}[hidden] {
        display: none !important;
      }

      #${LAUNCHER_ID}:focus-within {
        border-color: rgba(244, 214, 94, 0.72);
        box-shadow: 6px 8px 20px rgba(0, 0, 0, 0.34);
      }

      #${LAUNCHER_ID} button {
        appearance: none;
        font: inherit;
        color: inherit;
      }

      #${LAUNCHER_ID} .marston-discount-launcher__close {
        width: 22px;
        height: 22px;
        min-width: 22px;
        flex: 0 0 22px;
        display: grid;
        place-items: center;
        margin: 0;
        padding: 0;
        color: rgba(255, 255, 255, 0.82);
        background: transparent;
        border: 1px solid rgba(255, 255, 255, 0.38);
        border-radius: 50%;
        font-family: Arial, sans-serif;
        font-size: 18px;
        font-weight: 300;
        line-height: 1;
        cursor: pointer;
        transition: color 0.18s ease, background-color 0.18s ease, border-color 0.18s ease;
      }

      #${LAUNCHER_ID} .marston-discount-launcher__close:hover {
        color: #101010;
        background: #f4d65e;
        border-color: #f4d65e;
      }

      #${LAUNCHER_ID} .marston-discount-launcher__close:focus-visible,
      #${LAUNCHER_ID} .marston-discount-launcher__open:focus-visible {
        outline: 2px solid #f4d65e;
        outline-offset: 2px;
      }

      #${LAUNCHER_ID} .marston-discount-launcher__open {
        width: 100%;
        min-height: 0;
        flex: 1 1 auto;
        margin: 0;
        padding: 2px 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: inherit;
        background: transparent;
        border: 0;
        border-radius: 0 0 7px 0;
        cursor: pointer;
        transition: color 0.18s ease, background-color 0.18s ease;
      }

      #${LAUNCHER_ID} .marston-discount-launcher__open:hover {
        color: #f4d65e;
        background: rgba(255, 255, 255, 0.035);
      }

      #${LAUNCHER_ID} .marston-discount-launcher__label {
        display: block;
        writing-mode: vertical-rl;
        transform: rotate(180deg);
        color: inherit;
        font-size: 10px;
        font-weight: 800;
        line-height: 1;
        letter-spacing: 0.09em;
        white-space: nowrap;
      }

      @media screen and (max-width: 749px) {
        #${LAUNCHER_ID} {
          width: 35px;
          min-width: 35px;
          height: 108px;
          padding: 7px 3px 8px;
          gap: 4px;
          border-radius: 0 8px 8px 0;
        }

        #${LAUNCHER_ID} .marston-discount-launcher__close {
          width: 19px;
          height: 19px;
          min-width: 19px;
          flex-basis: 19px;
          font-size: 16px;
        }

        #${LAUNCHER_ID} .marston-discount-launcher__label {
          font-size: 9px;
          letter-spacing: 0.08em;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        #${LAUNCHER_ID},
        #${LAUNCHER_ID} .marston-discount-launcher__close,
        #${LAUNCHER_ID} .marston-discount-launcher__open {
          transition: none;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function dismissLauncher() {
    dismissed = true;
    rememberDismissed();

    const launcher = document.getElementById(LAUNCHER_ID);
    if (launcher) launcher.hidden = true;
  }

  function ensureLauncher() {
    let launcher = document.getElementById(LAUNCHER_ID);
    if (launcher) return launcher;

    ensureDocumentStyle();

    launcher = document.createElement('div');
    launcher.id = LAUNCHER_ID;
    launcher.hidden = true;
    launcher.innerHTML = `
      <button class="marston-discount-launcher__close" type="button" aria-label="Cerrar oferta del 10%" title="Cerrar">×</button>
      <button class="marston-discount-launcher__open" type="button" aria-label="Obtén 10% de descuento">
        <span class="marston-discount-launcher__label">OBTÉN 10%</span>
      </button>
    `;

    const closeButton = launcher.querySelector('.marston-discount-launcher__close');
    const openButton = launcher.querySelector('.marston-discount-launcher__open');

    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      dismissLauncher();
    });

    openButton.addEventListener('click', () => {
      const teaser = currentTeaser && currentTeaser.isConnected
        ? currentTeaser
        : findAvailableTeaser();

      if (!teaser) {
        launcher.hidden = true;
        return;
      }

      teaser.click();
    });

    document.body.appendChild(launcher);
    return launcher;
  }

  function hostIsAvailable(host) {
    if (!host || !host.isConnected) return false;

    const style = window.getComputedStyle(host);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function prepareHost(host) {
    if (!host || !host.shadowRoot || !hostIsAvailable(host)) return null;

    const root = host.shadowRoot;
    const teaser = findNativeTeaser(root);
    if (!teaser) return null;

    ensureShadowStyle(root);
    teaser.setAttribute(NATIVE_MARKER, 'true');
    return teaser;
  }

  function watchHost(host) {
    if (!host || !host.shadowRoot || watchedHosts.has(host)) return;

    watchedHosts.add(host);
    const observer = new MutationObserver(sync);
    observer.observe(host.shadowRoot, { childList: true, subtree: true });
  }

  function findAvailableTeaser() {
    const hosts = Array.from(document.querySelectorAll(HOST_SELECTOR));

    for (const host of hosts) {
      watchHost(host);
      const teaser = prepareHost(host);
      if (teaser) return teaser;
    }

    return null;
  }

  function sync() {
    const launcher = ensureLauncher();
    currentTeaser = findAvailableTeaser();
    launcher.hidden = dismissed || !currentTeaser;
  }

  const pageObserver = new MutationObserver(sync);

  function init() {
    dismissed = readDismissed();
    sync();
    pageObserver.observe(document.body, { childList: true, subtree: true });

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      ['shopify-forms-embed', 'form-embed'].forEach((tag) => {
        window.customElements.whenDefined(tag).then(sync).catch(() => {});
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
